<template>
  <div class="interview-control">
    <OfflineQualityControl
      :reviewTitle="'电话审核'"
      :reviewContent="'对电话访问的答卷进行人工审核'"
      :powerSubTitle="'（开启答题过程质控后，可在答卷详情中查看质控证据）'"
      :powerContent="'调查员可见电话调查时记录的多媒体素材'"/>
  </div>
</template>

<script>
import OfflineQualityControl from '@/views/survey/offline/OfflineQualityControl'

export default {
  name: "InterviewControl",
  components: { OfflineQualityControl },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
